import CarManagmentProvider, {
  useCarManagmentContext
} from 'providers/CarManagmentProvider';
import dayjs /* , { Dayjs }*/ from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
require('dayjs/locale/pt');
dayjs.extend(localeData);
dayjs.extend(LocalizedFormat);
dayjs.extend(weekday);
// import 'flatpickr/dist/themes/material_blue.css'; // or any theme
import BasicGanttChart, {
  Trip
} from 'components/charts/dhtmlx/BasicGanttChart';
import { useCallback, useMemo } from 'react';
import CalendarAddNewEventModal from 'components/modals/CarManagementAddNewTripModal';
import CalendarProvider from 'providers/CalendarProvider';
import { getPlannerPrefetchRange } from 'helpers/utils';

const index = () => {
  return (
    <CalendarProvider loadTripsOnMount={false}>
      <CarManagmentProvider loadTripsOnMount={false}>
        <Calendar />
      </CarManagmentProvider>
    </CalendarProvider>
  );
};

const Calendar = () => {
  const { plannerTrips, fetchTripsForRange, isLoadingTripRange, tripsError } =
    useCarManagmentContext();

  const handlePlannerDateChange = useCallback(
    (date: Date) => {
      void fetchTripsForRange(getPlannerPrefetchRange(date));
    },
    [fetchTripsForRange]
  );

  // const confirmedTrips = useMemo(() => {
  //   return (trips || [])
  //     .filter(trip => trip.status === 'Aprovado')
  //     .map(
  //       trip =>
  //         ({
  //           id: trip.id as number,
  //           text: trip.title,
  //           passenger: trip.passenger || trip.organizer || 'Unknown',
  //           start_date: new Date(trip.start),
  //           duration: trip.end
  //             ? (new Date(trip.end).getTime() -
  //                 new Date(trip.start).getTime()) /
  //               (1000 * 60 * 60)
  //             : 1,
  //           carPlate: trip.carPlate,
  //           originalStart: new Date(trip.start),
  //           originalEnd: new Date(trip.end || trip.start),
  //           isClipped: trip.takecar === 'Y' || trip.leavecar === 'N',
  //           isConfirmed: true,
  //           takeCar: trip.takecar,
  //           leaveCar: trip.leavecar
  //         }) as Trip
  //     );
  // }, [trips]);

  const confirmedTrips = useMemo(() => {
    const tripMap = new Map<string, Trip>();

    ([...plannerTrips].reverse() || [])
      .filter(trip => trip.status === 'Aprovado')
      .forEach(trip => {
        const originalStart = new Date(trip.start);
        const originalEnd = new Date(trip.end || trip.start);

        // Composite key to identify "same trip"
        const key = `${trip.carPlate}_${originalStart.getTime()}_${originalEnd.getTime()}`;

        if (tripMap.has(key)) {
          const existing = tripMap.get(key)!;
          const newPassenger = trip.passenger || trip.organizer || 'Unknown';

          // Extend passenger string if not already listed
          if (!existing.passenger.includes(newPassenger)) {
            existing.passenger = `${existing.passenger}, ${newPassenger}`;
          }
        } else {
          tripMap.set(key, {
            id: trip.id as number,
            grupo: trip.grupo,
            text: trip.title,
            passenger: trip.passenger || trip.organizer || 'Unknown',
            listPassenger: trip.usersList,
            outsideUsers: trip.outsideUsers,
            start_date: originalStart,
            end_date: originalEnd,
            duration: trip.end
              ? (new Date(trip.end).getTime() -
                  new Date(trip.start).getTime()) /
                (1000 * 60 * 60)
              : 1,
            carPlate: trip.carPlate,
            originalStart,
            originalEnd,
            isClipped: trip.takecar === 'Y' || trip.leavecar === 'N',
            isConfirmed: true,
            takeCar: trip.takecar,
            leaveCar: trip.leavecar
          } as Trip);
        }
      });

    return Array.from(tripMap.values());
  }, [plannerTrips]);

  return (
    <div>
      <BasicGanttChart
        trips={confirmedTrips}
        rightColumn="carPlate"
        initialViewMode={'week'}
        onPlannerDateChange={handlePlannerDateChange}
      />
      {tripsError && !isLoadingTripRange && (
        <div className="alert alert-danger" role="alert">
          {tripsError}
        </div>
      )}
      <CalendarAddNewEventModal />
    </div>
  );
};

export default index;
